<ng-container *transloco="let convert;">
  <div class="card" [ngClass]="{'removed-card': auctionItemSell$().auctionItemStatus === vehicleStatusFilter.REMOVED || auctionItemSell$().auctionItemStatus === vehicleStatusFilter.EXPIRED}">
    <!-- Processing vehicle status banner -->
    @if (showProcessingBanner$()) {
      <div class="card__processing-banner">
        <em class="allycon-warning warning-icon"></em>  {{ bannerTranslations.textProcessingVehicleStatus }}
      </div>
    }
    <!-- Processing vehicle arrived at storage location banner -->
    @if (showArrivedBanner) {
      <div class="card__processing-banner">
        <em class="allycon-success-fill text-success"></em> {{ bannerTranslations.textVehicleArrived }}
      </div>
    }
    <!-- Arbitration case banner -->
    @if (isSellerArbitrationEnabled) {
      <app-auction-summary-result-item-banner [bannerAlerts]="bannerAlerts"
      [tenantName]="tenantName$()"> </app-auction-summary-result-item-banner>
      <hr class="m-0">
    }
    <div class="card__top">
      <div class="stockwave-highlight-element">
        <div class="card__top-inner">
          <div class="card__top-mobile d-md-none d-flex justify-content-between">

            <!-- Checkbox for Action Bar -->
            @if (showActionBarCheckbox) {
              <div class="custom-control custom-checkbox bso-selection-mobile" >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  [id]="'action-bar-checkbox-mobile_' + auctionItemSell$()?.vehicleUuid"
                  (click)="toggleSelected()"
                  [checked]="isVehicleSelected$()"
                  [disabled]="disableActionBarCheckbox"
            [attr.aria-label]="vehicleCardTranslations.ariaLabelSelectAdd + detail('modelYear') + ' ' + detail('make') + ' '
            + detail('model') + ' ' + detail('trim') + ' ' + driveTrain"
                  >
                <label class="custom-control-label" [for]="'action-bar-checkbox-mobile_' + auctionItemSell$()?.vehicleUuid">
                </label>
              </div>
            }

            <button
              allytm-click-tagged="false"
              class="card__expand card__icon-button ms-auto"
              data-track-elem="accordion"
              data-track-trigger="statechange"
              [attr.data-track-state]="isCollapsed ? 'closed' : 'opened'"
              (click)="toggleCollapse()"
              [attr.aria-expanded]="!isCollapsed"
              [attr.aria-controls]="'collapseBasic-' + id"
              [attr.aria-label]="isCollapsed ? vehicleCardTranslations.ariaLabelExpandCard : vehicleCardTranslations.ariaLabelCollapseCard"
              >
              @if (!isCollapsed) {
                <img
                  src="../../../ui/assets/assets-{{ tenantName$() }}/{{ tenantName$() }}-collapse.svg"
                  alt="{{vehicleCardTranslations.altCollapse}}}"
                  />
              }
              @if (isCollapsed) {
                <img
                  src="../../../ui/assets/assets-{{ tenantName$() }}/{{ tenantName$() }}-expand.svg"
                  alt="{{vehicleCardTranslations.altExpand}}"
                  />
              }
            </button>
          </div>

          <hr />

          <div class="d-flex flex-row">
            <!-- Checkbox for Action Bar -->
            @if (showActionBarCheckbox) {
              <div class="custom-control custom-checkbox me-2 bso-selection-desktop">
                <input
                  type="checkbox"
                  data-test-id="vehicle-card-header-action-checkbox-desktop"
                  class="custom-control-input"
                  [id]="'action-bar-checkbox_' + auctionItemSell$()?.vehicleUuid"
                  (click)="toggleSelected()"
                  [checked]="isVehicleSelected$()"
                  [disabled]="disableActionBarCheckbox"
            [attr.aria-label]="vehicleCardTranslations.ariaLabelSelectAdd + detail('modelYear') + ' ' + detail('make') + ' '
            + detail('model') + ' ' + detail('trim') + ' ' + driveTrain"
                  >
                <label class="custom-control-label" [for]="'action-bar-checkbox_' + auctionItemSell$()?.vehicleUuid"></label>
              </div>
            }

            <!-- Images icons & Link -->
            @if (isShowVehicleImages) {
              <a
                data-test-id="vehicle-card-header-vehicle-image-link"
                data-track-elem="button"
                data-track-name="Vehicle Image"
                routerLink="/inventory/{{ auctionItemSell$()?.inventoryItemUuid }}/details"
                style="height: 39px; display: inline-block;"
                (click)="updateBackToInventory()"
                >
                <lib-images-count [img]="imgUrlLarge" [count]="auctionItemSell$()?.imageCount"></lib-images-count>
              </a>
            }
            <div class="stockwave-light-bulb-container"></div>
            <!-- Vehicle Info header -->
            <div class="vehicle-info full-width">
              <div class="vehicle-info__title" [class.vehicle-info__title--with-warning]="!isOfferListsTooltipEmpty && switchSharedWarningPositionToTopOfCard">
                <a
                  data-test-id="vehicle-card-header-vehicle-title-link"
                  data-track-elem="card id"
                  [attr.data-track-name]="auctionItemSell$()?.inventoryItemUuid + ' - MD' "
                  routerLink="/inventory/{{ auctionItemSell$()?.inventoryItemUuid }}/details"
                  [state]="{ fromSearch: true }"
                  [attr.aria-label]="title"
                  (click)="updateBackToInventory()"
                  >
                  <span>{{ detail('modelYear') }} </span>
                  <span>{{ detail('make') }} </span>
                  <span>{{ detail('model') }} </span>
                  <span>{{ detail('trim') }} </span>
                  <span>{{ driveTrain }}</span>
                </a>
                @if (!isOfferListsTooltipEmpty && switchSharedWarningPositionToTopOfCard) {
                  <div class="vehicle-title__shared-list-warning">
                    <ng-container *ngTemplateOutlet="sharedListWarning"></ng-container>
                  </div>
                }
              </div>
              <div class="vehicle-info__subtitle d-flex flex-wrap">
                <!-- VIN -->
                <div data-test-id="vehicle-card-header-vin-text" class="me-4 me-sm-4">
                  {{ (auctionItemSell$()?.itemDetail?.vin ? auctionItemSell$()?.itemDetail?.vin : vehicleCardTranslations.NA) | uppercase }}
                </div>
                <!-- Stock Unit Number -->
                <div class="stock-series-container">
                  <div class="me-4 me-sm-4 mobile-row-data stock-unit-container">
                    <span class="vehicle-info__subtitle-small me-1 me-sm-2">{{vehicleCardTranslations.stockNumber}}</span>
                    <span data-test-id="vehicle-card-header-stock-number-text">{{
                      (auctionItemSell$()?.itemDetail?.stockNumber ? auctionItemSell$()?.itemDetail?.stockNumber : vehicleCardTranslations.NA) | uppercase
                    }}</span>
                  </div>
                  <!-- Inspection Series -->
                  @if (isInspectionSeriesEnabled) {
                    <div class="mobile-row-data inspection-series-container">
                      <span class="vehicle-info__subtitle-small me-1 me-sm-2">{{vehicleCardTranslations.textInspectionSeriesLabel}}</span>
                      <span data-test-id="vehicle-card-header-inspection-series-text">{{
                        (auctionItemSell$()?.inspectionSeries ? auctionItemSell$()?.inspectionSeries : vehicleCardTranslations.NA) | uppercase
                      }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="card__top-mobile d-none d-md-block">
            <div class="card__top--icons">
              <!-- Print button -->
              @if (auctionItemSell$()?.auctionItemStatus === vehicleStatusFilter.SOLD) {
                <button
                  data-test-id="vehicle-card-header-print-icon-button"
                  #print
                  class="card__print card__icon-button icon-button me-md-1 me-lg-3"
                  printSectionId="{{ auctionItemSell$()?.vehicleUuid }}"
                  ngxPrint
                  useExistingCss="true"
                  data-track-name="button"
                  data-track-trigger="print"
                  data-track-elem="icon"
                  type="button"
                  tabIndex = -1
                  title="print"
                ></button>
              }
              <!-- ...more print stuff -->
              @if (auctionItemSell$()?.auctionItemStatus === vehicleStatusFilter.SOLD) {
                <button
                  data-test-id="vehicle-card-header-print-trigger-button"
                  class="card__print card__icon-button icon-button me-md-1 me-lg-3"
                  (click)="triggerPrint();"
                  [attr.data-track-name]="'Print Vehicle-' + title"
                  [attr.aria-label]="vehicleCardTranslations.ariaLabelPrintVehicle + title"
                  >
                  <i
                    class="allycon-print-outline tenant-icons"
                  ></i>
                </button>
              }

              <!-- Expand & Collapse Card Button -->
              <button
                data-test-id="vehicle-card-header-expand-button"
                allytm-click-tagged="false"
                class="card__expand card__icon-button"
                [ngClass]="{ 'card__expand--active': auctionItemSell$().auctionItemStatus === vehicleStatusFilter.ACTIVE }"
                data-track-elem="accordion"
                data-track-trigger="statechange"
                [attr.data-track-state]="isCollapsed ? 'closed' : 'opened'"
                (click)="toggleCollapse()"
                [attr.aria-expanded]="!isCollapsed"
                [attr.aria-controls]="'collapseBasic-' + id"
                [attr.aria-label]="isCollapsed ? vehicleCardTranslations.ariaLabelExpandCard : vehicleCardTranslations.ariaLabelCollapseCard"
                >
                @if (!isCollapsed) {
                  <img
                    src="../../../ui/assets/assets-{{ tenantName$() }}/{{ tenantName$() }}-collapse.svg"
                    alt="{{vehicleCardTranslations.altCollapse}}"
                    />
                }
                @if (isCollapsed) {
                  <img
                    src="../../../ui/assets/assets-{{ tenantName$() }}/{{ tenantName$() }}-expand.svg"
                    alt="{{vehicleCardTranslations.altExpand}}"
                    />
                }
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Expanded Card Format -->
      <div class="card__drawer">
        <div [id]="'collapseBasic-' + id" [collapse]="isCollapsed" role="application">

          <!-- ACTIVE AND RESERVED VEHICLES CARD FORMAT-->
          @if (auctionItemSell$()?.auctionItemStatus === vehicleStatusFilter.ACTIVE ||
            auctionItemSell$()?.auctionItemStatus === vehicleStatusFilter.RESERVED) {
            <div class="collapse-body vehicles-details__container">
              <div class="vehicles-details__inner">
                <!-- Mobile -->
                <div class="d-sm-block d-md-none">
                  <ul class="vehicles-details">
                    <!-- Column 1 -->
                    <div class="vehicle-column-mobile">
                      <ng-content *ngTemplateOutlet="sellerNameActive"></ng-content>
                      <ng-content *ngTemplateOutlet="location"></ng-content>
                      <ng-content *ngTemplateOutlet="days"></ng-content>
                      <ng-content *ngTemplateOutlet="hits"></ng-content>
                      <ng-content *ngTemplateOutlet="odometer"></ng-content>
                    </div>
                    <!-- Column 2 -->
                    <div class="vehicle-column-mobile">
                      <ng-content *ngTemplateOutlet="openingPrice"></ng-content>
                      <ng-content *ngTemplateOutlet="average"></ng-content>
                      @if (_vehicleSelectionsEnabled$()) {
                        <li class="vehicles-details__item">
                          <ng-content *ngTemplateOutlet="averageSalesPrice"></ng-content>
                        </li>
                      }
                      <ng-content *ngTemplateOutlet="buyNowPrice"></ng-content>
                      <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                      <li class="vehicles-details__item">
                        <ng-content *ngTemplateOutlet="tenant"></ng-content>
                      </li>
                    </div>
                  </ul>
                </div>
                <!-- Desktop -->
                <div class="d-none d-sm-none d-md-block">
                  <ul class="vehicles-details ">
                    <!-- Row 1 -->
                    <ng-content *ngTemplateOutlet="sellerNameActive"></ng-content>
                    <ng-content *ngTemplateOutlet="hits"></ng-content>
                    <ng-content *ngTemplateOutlet="openingPrice"></ng-content>
                    @if (_vehicleSelectionsEnabled$()) {
                      <li class="vehicles-details__item">
                        <ng-content *ngTemplateOutlet="averageSalesPrice"></ng-content>
                      </li>
                    }
                    <!-- Row 2 -->
                    @if (_vehicleSelectionsEnabled$()) {
                      <ng-content *ngTemplateOutlet="cohortUser"></ng-content>
                    } @else {
                      <li class="vehicles-details__item">
                        <ng-content *ngTemplateOutlet="days"></ng-content>
                      </li>
                      <li class="vehicles-details__item">
                        <ng-content *ngTemplateOutlet="location"></ng-content>
                      </li>
                    }
                    <ng-template #cohortUser>
                      <li class="vehicles-details__item">
                        <ng-content *ngTemplateOutlet="location"></ng-content>
                      </li>
                      <li class="vehicles-details__item">
                        <ng-content *ngTemplateOutlet="days"></ng-content>
                      </li>
                    </ng-template>

                    <ng-content *ngTemplateOutlet="odometer"></ng-content>
                    <ng-content *ngTemplateOutlet="average"></ng-content>
                    <ng-content *ngTemplateOutlet="buyNowPrice"></ng-content>
                    <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                    <!-- Row 3 -->
                    <li class="vehicles-details__item">
                      <ng-content *ngTemplateOutlet="tenant"></ng-content>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          }

          <!-- SOLD VEHICLE CARD FORMAT-->
          @if ((auctionItemSell$()?.auctionItemStatus === vehicleStatusFilter.SOLD) && isNotDirty) {
            <div class="collapse-body sold-vehicles__container my-3">
              <!-- Desktop -->
              @if (!isMobileLayout$()) {
                <div class="d-md-block">
                  <div class="sold-vehicles">
                    <div class="d-flex">
                      <div class="sold-vehicles__desktop-column">
                        <span class="text-uppercase d-block sold-vehicles__label" tabindex="-1" #expandFocusTarget
                          >{{vehicleCardTranslations.textMailTitle}}</span
                          >
                          <ng-content *ngTemplateOutlet="titleAddress"></ng-content>
                        </div>
                        <div class="sold-vehicles__desktop-column">
                          <span class="text-uppercase d-block sold-vehicles__label">{{vehicleCardTranslations.textBuyerInfo}}</span>
                          <ng-content *ngTemplateOutlet="buyerInfo"></ng-content>
                          <ng-content *ngTemplateOutlet="dealershipContact"></ng-content>
                          <ng-content *ngTemplateOutlet="buyerContactName"></ng-content>
                          <ng-content *ngTemplateOutlet="buyerEmail"></ng-content>
                          <ng-content *ngTemplateOutlet="buyerContact"></ng-content>
                          <ng-content *ngTemplateOutlet="buyerAuctionAccessId"></ng-content>
                          <ng-content *ngTemplateOutlet="buyerFinanceSource"></ng-content>
                          <ng-content *ngTemplateOutlet="customerId"></ng-content>
                        </div>
                        <ul class="sold-vehicles__desktop-column">
                          <ng-content *ngTemplateOutlet="sellerNameSold"></ng-content>
                          <ng-content *ngTemplateOutlet="tenantBadge"></ng-content>
                          <ng-content *ngTemplateOutlet="settlementDate"></ng-content>
                          <ng-content *ngTemplateOutlet="hits"></ng-content>
                          <ng-content *ngTemplateOutlet="bidCount"></ng-content>
                          <ng-content *ngTemplateOutlet="serviceFee"></ng-content>
                          <ng-content *ngTemplateOutlet="localDelivery"></ng-content>
                          @if (isSellerArbitrationEnabled) {
                            @if (!isOpenArbitration) {
                              <div>
                                <ng-content *ngTemplateOutlet="arbitration"></ng-content>
                              </div>
                            } @else {
                              <app-datalist-item class="ellipsis-overflow arbitration link d-block"
                                data-test-id="app-sold-vehicle-card-e-existing-arbitration-case-label"
                                label="{{vehicleCardTranslations.labelArbitration}}">
                                <a allytm-click-tagged='false'
                                  class="text-primary"
                                  data-test-id="app-sold-vehicle-card-e-existing-arbitration-case-link"
                                  routerLink="./arbitration/{{auctionItemSell$().vehicleUuid}}/{{claimNumber}}"
                                  [state]="{ scrollPosition: scrollPosition }" target="_self"
                                  data-track-elem="button"
                                  (click)="analyticsClickEvent(linkEvent, 'Case Opened ('+ claimNumber +')')">
                                  {{vehicleCardTranslations.textCaseOpened}} ({{ claimNumber }})
                                </a>
                              </app-datalist-item>
                            }
                            @if (closedArbitrationCases.length > 0) {
                              <div>
                                <ng-content *ngTemplateOutlet="arbitrationClosed"></ng-content>
                              </div>
                            }
                          }
                          <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                        </ul>
                      </div>
                    </div>
                  </div>
                }
                <!-- Mobile -->
                @if (isMobileLayout$()) {
                  <div class="d-sm-block d-md-none">
                    <div class="sold-vehicles">
                      <div class="d-flex justify-content-between">
                        <div class="sold-vehicles__titleInfo w-50">
                          <span class="text-uppercase d-block sold-vehicles__label" tabindex="-1" #expandFocusTarget
                            >{{vehicleCardTranslations.textMailTitle }}</span
                            >
                            <ng-content *ngTemplateOutlet="titleAddress"></ng-content>
                          </div>
                          <div class="sold-vehicles__buyerInfo w-50">
                            <span class="text-uppercase d-block sold-vehicles__label">{{vehicleCardTranslations.textBuyerInfo}}</span>
                            <ng-content *ngTemplateOutlet="buyerInfo"></ng-content>
                            <ng-content *ngTemplateOutlet="dealershipContact"></ng-content>
                            <ng-content *ngTemplateOutlet="buyerContactName"></ng-content>
                            <ng-content *ngTemplateOutlet="buyerEmail"></ng-content>
                            <ng-content *ngTemplateOutlet="buyerContact"></ng-content>
                            <ng-content *ngTemplateOutlet="buyerAuctionAccessId"></ng-content>
                            <ng-content *ngTemplateOutlet="buyerFinanceSource"></ng-content>
                            <ng-content *ngTemplateOutlet="customerId"></ng-content>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between mt-1">
                          <div class="sold-vehicles__seller w-50">
                            <ng-content *ngTemplateOutlet="sellerNameSold"></ng-content>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between mt-1">
                          <div class="sold-vehicles__tenantBadge w-50">
                            <ng-content *ngTemplateOutlet="tenantBadge"></ng-content>
                          </div>
                          <div class="sold-vehicles__settlementDate w-50">
                            <ng-content *ngTemplateOutlet="settlementDate"></ng-content>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between mt-1">
                          <div class="sold-vehicles__hits w-50">
                            <ng-content *ngTemplateOutlet="hits"></ng-content>
                          </div>
                          <div class="sold-vehicles__bidCount w-50">
                            <ng-content *ngTemplateOutlet="bidCount"></ng-content>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between mt-1">
                          <div class="sold-vehicles__serviceFee w-50">
                            <ng-content *ngTemplateOutlet="serviceFee"></ng-content>
                          </div>
                          <div class="sold-vehicles__bidCount w-50"></div>
                        </div>
                        <div class="d-flex justify-content-between mt-1">
                          <div class="sold-vehicles__local_delivery w-50">
                            <ng-content *ngTemplateOutlet="localDelivery"></ng-content>
                          </div>
                          <div class="sold-vehicles__bidCount w-50"></div>
                        </div>
                        <div class="d-flex justify-content-between mt-1">
                          @if (isSellerArbitrationEnabled) {
                            @if (!isOpenArbitration) {
                              <div class="w-50">
                                <ng-content *ngTemplateOutlet="arbitration"></ng-content>
                              </div>
                            } @else {
                              <app-datalist-item class="ellipsis-overflow arbitration link d-block"
                                data-test-id="app-sold-vehicle-card-e-existing-arbitration-case-label"
                                label="{{vehicleCardTranslations.labelArbitration}}">
                                <a allytm-click-tagged='false'
                                  class="text-primary"
                                  data-test-id="app-sold-vehicle-card-e-existing-arbitration-case-link"
                                  routerLink="./arbitration/{{auctionItemSell$().vehicleUuid}}/{{claimNumber}}"
                                  [state]="{ scrollPosition: scrollPosition }" target="_self"
                                  data-track-elem="button"
                                  (click)="analyticsClickEvent(linkEvent, 'Case Opened ('+ claimNumber +')')">
                                  {{vehicleCardTranslations.textCaseOpened}} ({{ claimNumber }})
                                </a>
                              </app-datalist-item>
                            }
                            @if (closedArbitrationCases.length > 0) {
                              <div class="w-50">
                                <ng-content *ngTemplateOutlet="arbitrationClosed"></ng-content>
                              </div>
                            }
                          }
                        </div>
                        <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                      </div>
                    </div>
                  }
                </div>
              }

              <!-- HOLD Vehicle Card Format -->
              @if (auctionItemSell$()?.auctionItemStatus === vehicleStatusFilter.HOLD) {
                <div class="collapse-body vehicles-details__container">
                  <div class="vehicles-details__inner">
                    <!-- Mobile -->
                    <div class="d-sm-block d-md-none">
                      <ul class="vehicles-details">
                        <ng-content *ngTemplateOutlet="daysOnHold"></ng-content>
                        <ng-content *ngTemplateOutlet="sellerNameSold"></ng-content>
                        <ng-content *ngTemplateOutlet="postingPrice"></ng-content>
                        <ng-content *ngTemplateOutlet="holdReasonTmpl"></ng-content>
                        <ng-content *ngTemplateOutlet="buyNowPrice"></ng-content>
                        <ng-content *ngTemplateOutlet="hits"></ng-content>
                        <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                      </ul>
                    </div>
                    <!-- Desktop -->
                    <div class="d-none d-sm-none d-md-block">
                      <ul class="vehicles-details ">
                        <ng-content *ngTemplateOutlet="daysOnHold"></ng-content>
                        <ng-content *ngTemplateOutlet="hits"></ng-content>
                        <ng-content *ngTemplateOutlet="postingPrice"></ng-content>
                        <ng-content *ngTemplateOutlet="buyNowPrice"></ng-content>
                        <ng-content *ngTemplateOutlet="holdReasonTmpl"></ng-content>
                        <ng-content *ngTemplateOutlet="sellerNameSold"></ng-content>
                        <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                      </ul>
                    </div>
                  </div>
                </div>
              }

              <!-- REMOVED and EXPIRED Vehicle Card Format -->
              @if (auctionItemSell$()?.auctionItemStatus === vehicleStatusFilter.REMOVED || auctionItemSell$()?.auctionItemStatus === vehicleStatusFilter.EXPIRED) {
                <div class="collapse-body vehicles-details__container">
                  <div class="vehicles-details__inner">
                    <!-- Mobile -->
                    <div class="d-sm-block d-md-none">
                      <div class="vehicles-details">
                        <div class="vehicle-column-mobile">
                          <ng-content *ngTemplateOutlet="removalReason"></ng-content>
                          <ng-content *ngTemplateOutlet="postedDate"></ng-content>
                          <ng-content *ngTemplateOutlet="removals"></ng-content>
                          <ng-content *ngTemplateOutlet="hits"></ng-content>
                          <ng-content *ngTemplateOutlet="bidListAdds"></ng-content>
                          <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                        </div>
                        <div class="vehicle-column-mobile mt-2">
                          <ng-content *ngTemplateOutlet="sellerNameSold"></ng-content>
                          <ng-content *ngTemplateOutlet="postingPrice"></ng-content>
                          <ng-content *ngTemplateOutlet="buyNowPrice"></ng-content>
                          <ng-content *ngTemplateOutlet="fees"></ng-content>
                          <ng-content *ngTemplateOutlet="highestOfferPrice"></ng-content>
                        </div>
                      </div>
                    </div>
                    <!-- Desktop -->
                    <div class="d-none d-sm-none d-md-block">
                      <div class="vehicles-details">
                        <ul class="removed-vehicle-row">
                          <ng-content *ngTemplateOutlet="removalReason"></ng-content>
                          <ng-content *ngTemplateOutlet="postedDate"></ng-content>
                          <ng-content *ngTemplateOutlet="removals"></ng-content>
                          <ng-content *ngTemplateOutlet="hits"></ng-content>
                        </ul>
                        <ul class="removed-vehicle-row">
                          <ng-content *ngTemplateOutlet="sellerNameActive"></ng-content>
                          <ng-content *ngTemplateOutlet="bidListAdds"></ng-content>
                          <ng-content *ngTemplateOutlet="postingPrice"></ng-content>
                          <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                        </ul>
                        <ul class="removed-vehicle-row">
                          <ng-content *ngTemplateOutlet="buyNowPrice"></ng-content>
                          <ng-content *ngTemplateOutlet="fees"></ng-content>
                          <ng-content *ngTemplateOutlet="highestOfferPrice"></ng-content>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Card Actions -->
        <div class="card__actions">
          <div class="card__actions-inner">
            <div
              class="card__actions-inner__indicator"
              [ngClass]="getStatusIndicatorClass()"
              >
              <lib-state-indicator [identifier]="'inventory_block_status_' + index$()" [variant]="status.variant">
              </lib-state-indicator>
            </div>
            <div class="card__actions-inner__status d-flex">

              <!-- ACTIVE CARD ACTIONS -->
              @if (auctionItemSell$()?.auctionItemStatus === vehicleStatusFilter.ACTIVE) {
                <!-- Row 1 -->
                <span class="mobile-row mobile-border">
                  @if (showAuctionEndTime) {
                    <i class="allycon-clock ms-2 clock" aria-hidden="true"></i>
                  }
                  @if (showAuctionStartTime || showAuctionStartTimePending || showAuctionExtendTime) {
                    <i
                      class="allycon-sm-calendar ms-2 clock"
                      aria-hidden="true"
                    ></i>
                  }
                  <span class="time" [ngClass]="getBidStatusClasses()">
                    <span class="time__label me-2 d-none d-md-inline">
                      @if (showAuctionStartTime || showAuctionStartTimePending) {
                        <strong>{{vehicleCardTranslations.textStartDate}}</strong>
                      }
                      @if (showAuctionEndTime || showAuctionExtendTime) {
                        <strong>{{vehicleCardTranslations.textEndDate}}</strong>
                      }
                    </span>
                    @if (showAuctionStartTime) {
                      <span
                        data-test-id="vehicle-card-actions-auction-start-time"
                        class="time__content"
                        >{{ auctionStartTime }}
                      </span>
                    }
                    @if (showAuctionExtendTime) {
                      <span
                        data-test-id="vehicle-card-actions-auction-extended-time"
                        class="time__content"
                        >{{ auctionExtendedTime }}</span
                        >
                      }
                      @if (showAuctionEndTime) {
                        <span
                          data-test-id="vehicle-card-actions-auction-end-time"
                          class="time__content"
                          >{{ auctionEndTime }}</span
                          >
                        }
                        @if (showAuctionStartTimePending) {
                          <span
                            class="time__content"
                            >{{vehicleCardTranslations.textPending}}
                          </span>
                        }
                      </span>
                    </span>
                    <!-- Row 2 -->
                    <span class="mobile-row mobile-border">
                      @if (!auctionItemSell$()?.openingPrice) {
                        <span class="divider" [ngClass]="getBidStatusClasses()">|</span>
                      }
                      @if (!auctionItemSell$()?.openingPrice) {
                        <span
                          class="bid_status fw-bold"
                          [ngClass]="getBidStatusClasses()"
                          [id]="'manage_inventory_common_card_bid_status'"
                          >
                          {{ bidStatus }}
                        </span>
                      }
                      @if (auctionItemSell$()?.openingPrice) {
                        <span class="divider" [ngClass]="getBidStatusClasses()">|</span>
                      }
                      @if (!auctionItemSell$()?.openingPrice) {
                        <span class="divider" [ngClass]="getBidStatusClasses()">|</span>
                      }
                      <strong class="highest-offer-label"
                        [ngStyle]="(isMobileLayout$() && auctionItemSell$()?.openingPrice) ? {'margin-left': '8px'} : ''">
                        {{vehicleCardTranslations.textHighestOffer}}
                      </strong>
                      <span data-test-id="vehicle-card-actions-highest-offer-value" class="spacer"> {{ highestOffer ? formatCurrency(highestOffer): vehicleCardTranslations.NA}}</span>
                      <ng-content *ngTemplateOutlet="totalPrice"></ng-content>
                    </span>
                    <!-- Historical High -->
                    @if (showHistoricalHigh) {
                      <span class="mobile-row mobile-border"
                      data-test-id="app-vehicle-card-historicalHigh">
                        <span class="divider">|</span>
                        <strong class="historical-high-label" data-test-id="app-vehicle-card-historicalHigh-label"
                          [ngClass]="{'ms-2': isMobileLayout$() && auctionItemSell$()?.openingPrice}">{{ vehicleCardTranslations.textHistoricalHigh }}
                        </strong>
                        <span class="spacer"
                          data-test-id="app-vehicle-card-historicalHigh-value">
                          {{ getAuctionItemSellProp('highestHistoricalOffer', false) ? formatCurrency(getAuctionItemSellProp('highestHistoricalOffer', false)) : vehicleCardTranslations.NA }}</span>
                        <span>
                          <app-tooltip
                            id="historicalHighTooltip"
                            data-test-id="app-vehicle-card-historicalHigh-tooltip"
                            [tooltip]="historicalHighTooltip"
                            [showToolTipAsHtml]="true"
                            triggers="click :keydown.escape :keydown.tab"
                            (click)="analyticsInfo('Historical High Details')"
                            allytmln="historical high tooltip">
                            <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"
                              data-test-id="app-vehicle-card-historicalHigh-tooltip-icon"
                            ></i>
                          </app-tooltip>
                        </span>
                      </span>
                    }
                    <!-- Row 3 -->
                    @if (auctionItemSell$().vehicleTypeCode !== 'ISV') {
                      <span class="mobile-row">
                        <span class="status_offers_questions" [ngClass]="getBidStatusClasses()">
                          <span class="divider" [ngClass]="getBidStatusClasses()">|</span>
                          <a
                            data-test-id="vehicle-card-actions-offers-link"
                            href="#"
                            data-track-elem="button"
                            [attr.data-track-name]="'Offers-' + auctionItemSell$()?.inventoryItemUuid"
                            class="action mx-2"
                            (click)="updateBackToInventory()"
                            routerLink="/inventory/{{ auctionItemSell$()?.inventoryItemUuid }}/offers"
                            >
                            <strong>{{vehicleCardTranslations.textOffers}}</strong>
                            @if (openOfferCount > 0) {
                              <span class="action-badge">{{ getAuctionItemOfferCount }}</span>
                            }
                          </a>
                          @if (!inServiceVehiclesEnabled) {
                            <span class="divider">|</span>
                            <a
                              data-test-id="vehicle-card-actions-questions-link"
                              href="#"
                              data-track-elem="button"
                              [attr.data-track-name]="'Questions-' + auctionItemSell$()?.inventoryItemUuid"
                              class="action"
                              (click)="updateBackToInventory()"
                              routerLink="/inventory/{{ auctionItemSell$()?.inventoryItemUuid }}/questions"
                              >
                              <strong>{{vehicleCardTranslations.textQuestions}}</strong>
                              @if (openQuestionCount > 0) {
                                <div class="action-badge">
                                  {{ openQuestionCount }}
                                </div>
                              }
                            </a>
                          }
                          @if (!inServiceVehiclesEnabled) {
                            @if (_vehicleSelectionsEnabled$()) {
                              <span class="divider">|</span>
                            }
                            @if (_vehicleSelectionsEnabled$()) {
                              <span>
                                <a
                                  data-test-id="vehicle-card-actions-edit-link"
                                  data-track-elem="button"
                                  [class]="isEditDisabled ? 'action__disabled' : 'action'"
                                  (click) = isEditCutOffTime()
                                  [ngClass] = "{'disableEdit':isEditDisabled,'enableEdit':!isEditDisabled}"
                                  tabindex="0">
                                  <strong>{{vehicleCardTranslations.textEdit}}</strong>
                                </a>
                              </span>
                            }
                            <span class="divider">|</span>
                          }
                        </span>
                      </span>
                    }
                    <!-- Row 4 -->
                    @if (!isOfferListsTooltipEmpty) {
                      <div [class.vehicle-row4__shared-list-warning]="switchSharedWarningPositionToTopOfCard">
                        <ng-container *ngTemplateOutlet="sharedListWarning"></ng-container>
                      </div>
                    }
                  }

                  <!-- SOLD VEHICLE CARD ACTIONS -->
                  @if (auctionItemSell$().auctionItemStatus === vehicleStatusFilter.SOLD) {
                    <span class="mobile-row mobile-border">
                      <i class="allycon-sm-calendar ms-md-2 clock" aria-hidden="true"></i>
                      <span class="time">
                        <span class="time__label me-2 d-none d-md-inline">
                          <strong class="text-uppercase">{{vehicleCardTranslations.textSaleDate}}</strong>
                        </span>
                        <span data-test-id="vehicle-card-actions-sale-date-time" class="time__content">{{
                          saleDateTime
                        }}</span>
                      </span>
                      <span class="divider">|</span>
                      <span data-test-id="vehicle-card-actions-sold-status-text" class="action btn-link">
                        <b>{{ convert(auctionItemSell$().auctionItemStatus | titlecase) }}</b>
                      </span>
                    </span>
                    @if (singleListSelected$()) {
                      <span>
                        <span class="mobile-row mobile-border sold-service-sell-fee-details">
                          <span class="divider">|</span>
                          <span class="text-uppercase me-2 sold-vehicles-label">
                            {{vehicleCardTranslations.textSaleFee}}
                          </span>
                          <span>
                            {{formatCurrency(sellFeesTotalAmount)}}
                          </span>
                          @if (sellFeeTooltip) {
                            <span>
                              <app-tooltip data-test-id="vehicle-card-actions-sell-fee-tooltip" [tooltip]="sellFeeDetailsTooltip" [showToolTipAsHtml]="true"
                                triggers="click :keydown.escape :keydown.tab" (click)="analyticsInfo('Sell Fee Details')"
                                allytmln="Sell Fee Details">
                                <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                              </app-tooltip>
                            </span>
                          }
                          <ng-content *ngTemplateOutlet="totalPrice"></ng-content>
                        </span>
                      </span>
                    }
                    @if (!singleListSelected$()) {
                      <span>
                        <span class="mobile-row mobile-border sold-service-details">
                          <span class="divider">|</span>
                          <span class="text-uppercase me-2 sold-vehicles-label">
                            {{vehicleCardTranslations.textSaleFee}}
                          </span>
                          <span>
                            {{sellFeesTotalAmount ? formatCurrency(sellFeesTotalAmount, true): vehicleCardTranslations.NA}}
                          </span>
                          @if (sellFeeTooltip) {
                            <span>
                              <app-tooltip data-test-id="vehicle-card-actions-sell-fee-details-tooltip" [tooltip]="sellFeeDetailsTooltip" [showToolTipAsHtml]="true"
                                triggers="click :keydown.escape :keydown.tab" (click)="analyticsInfo('Sell Fee Details')"
                                allytmln="Sell Fee Details">
                                <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                              </app-tooltip>
                            </span>
                          }
                          <span class="divider">|</span>
                          <span class="text-uppercase me-2 sold-vehicles-label">
                            {{vehicleCardTranslations.textSalePrice}}
                          </span>
                          {{auctionItemSell$().salePrice ? formatCurrency(auctionItemSell$().salePrice) : vehicleCardTranslations.NA}}
                        </span>
                      </span>
                    }
                    <!-- Proceeds Status Admin SAT-67088-->
                    @if (isProceedsDisplay) {
                      <span class="mobile-row mobile-border">
                        <span class="divider">|</span>
                        @if (this.auctionItemSell$().holdProceedsTypeCode == 'H') {
                          <span class="time__label mr-2 d-md-inline">
                            <strong data-test-id="app-vehicle-card-release-proceeds-held-text" class="text-uppercase">PROCEEDS HELD</strong>
                          </span>
                        }
                        @if (this.auctionItemSell$().holdProceedsTypeCode == 'R') {
                          <span class="time">
                            <span class="time__label me-2 d-md-inline">
                              <strong data-test-id="app-vehicle-card-release-proceeds-released-text" class="text-uppercase">PROCEEDS RELEASED:</strong>
                            </span>
                            <span class="time__content">{{
                              releasedDate
                            }}</span>
                          </span>
                        }
                      </span>
                    }
                    <div>
                      <span class="divider">|</span>
                    </div>
                    <div class=" history-wrapper">
                      <button
                        data-test-id="vehicle-card-actions-view-history-button"
                        class="btn btn-link p-0 view-history-action card__actions-inner__status--history outline-focus"
                        data-track-elem="button"
                        [attr.aria-label]="vehicleCardTranslations.ariaLabelViewHistory + title"
                        [attr.data-track-name]="'View History-' + auctionItemSell$()?.inventoryItemUuid"
                        [ngClass]="{ 'view-history-action__active': showSoldHistory }"
                        (click)="displaySoldHistory($event)"
                        >
                        {{vehicleCardTranslations.ariaLabelViewHistory}}
                      </button>
                    </div>
                  }

                  <!-- HOLD VEHICLE CARD ACTIONS -->
                  @if (auctionItemSell$().auctionItemStatus === vehicleStatusFilter.HOLD) {
                    <span class="mobile-row">
                      <i class="allycon-sm-calendar ms-md-2 clock" aria-hidden="true"></i>
                      <span class="time">
                        <span class="time__label me-2 d-none d-md-inline">
                          <strong class="text-uppercase">{{vehicleCardTranslations.textOnHold}}</strong>
                        </span>
                        <span class="time__content">{{
                          statusChangedDate
                        }}</span>
                      </span>
                      @if (isHoldActionsEnabled) {
                        <span class="divider">|</span>
                        <a
                          data-test-id="vehicle-card-actions-hold-edit-link"
                          [href]="isEditDisabled ? null : '#'"
                          [routerLink]="isEditDisabled ? null
                           : '/inventory/edit/' + auctionItemSell$()?.inventoryItemUuid"
                          (click)="updateBackToInventory()"
                          data-track-elem="button"
                          [class]="isEditDisabled ? 'action__disabled' : 'action'"
                          >
                          <strong>{{vehicleCardTranslations.textEdit}}</strong>
                        </a>
                      }
                    </span>
                  }

                  <!-- REMOVED & EXPIRED VEHICLE CARD ACTIONS -->
                  @if (auctionItemSell$().auctionItemStatus === vehicleStatusFilter.REMOVED || auctionItemSell$().auctionItemStatus === vehicleStatusFilter.EXPIRED) {
                    <span class="mobile-row mobile-border">
                      <i class="allycon-sm-calendar ms-md-2 clock removed-clock" aria-hidden="true"></i>
                      <span class="time">
                        <span class="time__label me-2 d-md-inline">
                          <strong class="text-uppercase">{{vehicleCardTranslations.textRemovedDate}}</strong>
                        </span>
                        <span class="time__content">{{
                          statusChangedDate
                        }}</span>
                      </span>
                    </span>
                    <span class="mobile-row removed-history-wrapper align-items-center">
                      @if (isRemovedActionsEnabled && auctionItemSell$().removalCount > 1) {
                        <span class="divider ">|</span>
                        <button
                          data-test-id="vehicle-card-actions-view-posting-history-button"
                          class="btn btn-link p-0 view-history-action card__actions-inner__status--history outline-focus"
                          data-track-elem="button"
                          [attr.aria-label]="vehicleCardTranslations.textViewPostingHistory + title"
                          [attr.data-track-name]="'View Posting History-' + auctionItemSell$()?.inventoryItemUuid"
                          [ngClass]="{ 'view-history-action__active': showRemovedHistory }"
                          (click)="displayRemovedHistory($event)"
                          >
                          {{vehicleCardTranslations.textViewPostingHistory}}
                        </button>
                      }
                      @if (isRemovedActionsEnabled && !auctionItemSell$().repostedDate && !isVinDecodeRequired()) {
                        <span class="divider ">|</span>
                        <a
                          data-test-id="vehicle-card-actions-repost-link"
                          [href]="'#'"
                          data-track-elem="button"
                          class="action ignore-history-wrapper"
                          (click)="onClickRepost($event, auctionItemSell$()?.itemDetail.vin)"
                          >
                          <strong>{{vehicleCardTranslations.textRepost}}</strong>
                        </a>
                      }
                      @if (auctionItemSell$().repostedDate) {
                        <span class="divider ">|</span>
                        <strong class="text-muted">{{vehicleCardTranslations.textRepostedOn}} {{ localizeDateAndTime(auctionItemSell$().repostedDate) }}</strong>
                      }
                    </span>
                  }
                </div>
              </div>
            </div>

            <!-- Purchase History-->
            @if (showSoldHistory) {
              <div class="history">
                <app-purchase-history
                  data-test-id="vehicle-card-history-purchase-history"
                  [vehicleVin]="auctionItemSell$().itemDetail.vin"
                  [saleDate]="saleDateTime"
                  [salePrice]="auctionItemSell$().salePrice"
                  [auctionItemUuid]="auctionItemSell$().vehicleUuid"
                  [isVisible]="showSoldHistory"
                  (close)="showSoldHistory = !showSoldHistory"
                ></app-purchase-history>
              </div>
            }

            <div class="print-section">
              <ng-content *ngTemplateOutlet="printContent"></ng-content>
            </div>
            @if (showRemovedHistory) {
              <div class="removal-history">
                <app-removal-history
                  data-test-id="vehicle-card-history-removal-history"
                  [auctionItemUuid]="auctionItemSell$().vehicleUuid"
                  (close)="showRemovedHistory = !showRemovedHistory"
                  [isVisible]="showRemovedHistory"
                ></app-removal-history>
              </div>
            }
          </div>

          <!-- CARD BY STATUS TEMPLATES END -->





          <!-- CARD DETAIL TEMPLATES -->
          <ng-template #location>
            <div class="vehicles-details__item">
              <span data-test-id="vehicle-card-details-location-label" class="vehicles-details__label">{{vehicleCardTranslations.textLocation}} </span>
              <span data-test-id="vehicle-card-details-location-data" class="vehicles-details__data">{{storageLocationCityState}}</span>
            </div>
          </ng-template>

          <ng-template #average>
            <li class="vehicles-details__item">
              <span data-test-id="vehicle-card-details-book-value-label" class="vehicles-details__label"
                >{{ bookProvider | uppercase }}:
              </span>
              <span data-test-id="vehicle-card-details-book-value-data" class="vehicles-details__data">{{
                getSpreadToBookValue() ? formatCurrency(getSpreadToBookValue()) : vehicleCardTranslations.NA
              }}</span>
            </li>
          </ng-template>

          <ng-template #days>
            <div class="vehicles-details__item">
              <span data-test-id="vehicle-card-details-days-remaining-label" class="vehicles-details__label">{{vehicleCardTranslations.textDaysRemaining}} </span>
              <span data-test-id="vehicle-card-details-days-remaining-data" class="vehicles-details__data">{{
                getAuctionItemSellProp('daysRemainingInAuction', 0)
              }}</span>
            </div>
          </ng-template>

          <ng-template #openingPrice>
            <li class="vehicles-details__item">
              @if (auctionItemSell$()?.openingPrice) {
                <span data-test-id="vehicle-card-details-opening-price-label" class="vehicles-details__label">{{vehicleCardTranslations.textOpeningPrice}} </span>
              }
              @if (!auctionItemSell$()?.openingPrice) {
                <span data-test-id="vehicle-card-details-current-bid-label" class="vehicles-details__label">{{vehicleCardTranslations.textCurrentBid}} </span>
              }
              <span
                data-test-id="vehicle-card-details-price-data"
                class="vehicles-details__data">{{
                getAuctionItemSellProp('currentAmount', false) ? formatCurrency(getAuctionItemSellProp('currentAmount', false)) : vehicleCardTranslations.NA
                }}</span
                >
              </li>
            </ng-template>

            <ng-template #odometer>
              <li class="vehicles-details__item">
                <span data-test-id="vehicle-card-details-odometer-label" class="vehicles-details__label">{{vehicleCardTranslations.textOdometer}} </span>
                <span data-test-id="vehicle-card-details-odometer-data" class="vehicles-details__data">
                  {{ getAuctionItemSellProp('itemDetail.odometer', false) ? (getAuctionItemSellProp('itemDetail.odometer') | number) + ' ' + vehicleCardTranslations.distanceUnit : vehicleCardTranslations.NA }}
                </span>
              </li>
            </ng-template>

            <ng-template #hits>

              <li
                [ngClass]="(
                auctionItemSell$().auctionItemStatus === vehicleStatusFilter.ACTIVE
                || auctionItemSell$().auctionItemStatus === vehicleStatusFilter.HOLD
                || auctionItemSell$().auctionItemStatus === vehicleStatusFilter.REMOVED
                || auctionItemSell$().auctionItemStatus === vehicleStatusFilter.EXPIRED
                || auctionItemSell$().auctionItemStatus === vehicleStatusFilter.RESERVED
                || StatusFilter.SHARED_VEHICLES === inventoryCurrentStatus$()) ?'vehicles-details__item noBulletPoint' : 'sold-vehicles__list-item noBulletPoint'">
                <span data-test-id="vehicle-card-details-hits-label" class="vehicles-details__label">{{vehicleCardTranslations.textHits}} </span>
                <span data-test-id="vehicle-card-details-hits-data" class="vehicles-details__data">{{
                  getAuctionItemSellProp('viewCount', 0)
                }}</span>
              </li>
            </ng-template>

            <ng-template #buyNowPrice>
              <li class="vehicles-details__item">
                <span data-test-id="vehicle-card-details-buy-now-price-label" class="vehicles-details__label">{{vehicleCardTranslations.textBuyNowPrice}} </span>
                <span data-test-id="vehicle-card-details-buy-now-price-data" class="vehicles-details__data">{{
                  getAuctionItemSellProp('buyNowAllowed', false) && getAuctionItemSellProp('buyNowAmount', false)
                  ? formatCurrency(getAuctionItemSellProp('buyNowAmount', false))
                  : vehicleCardTranslations.NA
                }}</span>
              </li>
            </ng-template>

            <ng-template #averageSalesPrice>
              <span data-test-id="vehicle-card-details-avg-sales-price-label" class="vehicles-details__label">{{vehicleCardTranslations.textAverageSalesPrice}} </span>
              <span data-test-id="vehicle-card-details-avg-sales-price-data" class="vehicles-details__data">
                {{ getAuctionItemSellProp('averageSalesPrice', false) ? formatCurrency(getAuctionItemSellProp('averageSalesPrice', 0)) : vehicleCardTranslations.NA}}
              </span>
            </ng-template>

            <ng-template #tenant>
              @if (isTenantBadgeEnabled) {
                <span data-test-id="vehicle-card-details-tenant-badge-label" class="vehicles-details__label">{{vehicleCardTranslations.textTenantBadge}} </span>
                <span data-test-id="vehicle-card-details-tenant-badge-data" class="vehicles-details__data">
                  {{getAuctionItemSellProp('auctionTenant', false) ? getAuctionItemSellProp('auctionTenant', false) : vehicleCardTranslations.NA}}
                </span>
              }
            </ng-template>

            <ng-template #titleAddress>
              <div class="sold-vehicles__item sold-vehicles__titleAddress">
                <!-- Title Address Name-->
                <span
                  data-test-id="vehicle-card-sold-title-address-name"
                  class="sold-vehicles__item--data sold-vehicles__titleAddress--name"
                  >{{ titleAddressName }}
                </span>
                <!-- Title Address Street-->
                <span
                  data-test-id="vehicle-card-sold-title-address-street"
                  class="sold-vehicles__item--data sold-vehicles__titleAddress--address"
                  >{{ titleAddressDetail }}
                </span>
                <!-- Title Address 2 -->
                <span
                  data-test-id="vehicle-card-sold-title-address-line2"
                  class="sold-vehicles__item--data sold-vehicles__titleAddress--address2"
                  >{{ titleAddressDetail2 }}
                </span>
                <!-- Title Address Region -->
                <span
                  data-test-id="vehicle-card-sold-title-address-region"
                  class="sold-vehicles__item--data sold-vehicles__titleAddress--region"
                  >{{ titleAddressRegion }}
                </span>
                @if (isTitleContactEnabled) {
                  <!-- Title Contact Name -->
                  <span class="sold-vehicles__item--data sold-vehicles__titleAddress--contact-name mt-2">
                    <span class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textTitleContactName}}</span> {{ titleContactName }}
                  </span>
                  <!-- Title Contact Email -->
                  <span class="sold-vehicles__item--data sold-vehicles__titleAddress--contact-email mt-2">
                    <span class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textTitleContactEmail}}</span> {{ titleContactEmail }}
                  </span>
                  <!-- Title Contact Phone -->
                  <span class="sold-vehicles__item--data sold-vehicles__titleAddress--contact-phone mt-2">
                    <span class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textTitleContactPhone}}</span>
                    @if (titleContactPhone) {
                      <a
                        class="phone-link"
                        data-track-name="phone"
                        [attr.data-track-elem]="titleContactPhone | formatPhoneNumber"
                        [href]="titleContactPhone | telephoneLink"
                        [attr.aria-label]="vehicleCardTranslations.ariaLabelCall + (titleContactPhone | formatPhoneNumber)"
                        >{{ titleContactPhone | formatPhoneNumber }}</a>
                    } @else {
                      {{vehicleCardTranslations.NA}}
                    }
                  </span>
                }
              </div>
            </ng-template>

            <ng-template #buyerInfo>
              <div class="sold-vehicles__item  sold-vehicles__buyerInfo">
                <!-- Buyer Detail Name-->
                <span
                  data-test-id="vehicle-card-sold-buyer-name"
                  class="sold-vehicles__item--data sold-vehicles__buyerInfo--dealership-name"
                  >{{ buyerDetailsName }}
                </span>
                <!-- Buyer Detail address-->
                <span
                  data-test-id="vehicle-card-sold-buyer-address"
                  class="sold-vehicles__item--data sold-vehicles__buyerInfo--address"
                  >{{ buyerDetailsAddress }}
                </span>
                <!-- Buyer Detail address2-->
                <span
                  data-test-id="vehicle-card-sold-buyer-address-line2"
                  class="sold-vehicles__item--data sold-vehicles__buyerInfo--address2"
                  >{{ buyerDetailsAddress2 }}
                </span>
                <!-- Buyer Detail Region-->
                <span
                  data-test-id="vehicle-card-sold-buyer-region"
                  class="sold-vehicles__item--data sold-vehicles__buyerInfo--region"
                  >{{ buyerDetailRegion }}
                </span>
              </div>
            </ng-template>

            <ng-template #dealershipContact>
              <div class="sold-vehicles__item sold-vehicles__dealership-contact mt-md-2">
                <span data-test-id="vehicle-card-sold-dealership-contact-label" class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textDealershipContact}}</span>
                <span class="sold-vehicles__data--buyer-contact">
                  @if (buyerDetailsPrimaryPhone) {
                    <a
                      data-test-id="vehicle-card-sold-dealership-phone-link"
                      class="sold-vehicles__item--data sold-vehicles__buyerInfo--dealership-phone phone-link"
                      data-track-name="phone"
                      [attr.data-track-elem]="buyerDetailsPrimaryPhone | formatPhoneNumber"
                      [href]="buyerDetailsPrimaryPhone | telephoneLink"
                      [attr.aria-label]="vehicleCardTranslations.ariaLabelCall + buyerDetailsPrimaryPhone"
                      >
                      {{ buyerDetailsPrimaryPhone | formatPhoneNumber }}
                    </a>
                  }
                  @if (!buyerDetailsPrimaryPhone) {
                    <span data-test-id="vehicle-card-sold-dealership-phone-na">{{vehicleCardTranslations.NA}}</span>
                  }
                </span>
              </div>
            </ng-template>

            <ng-template #buyerContactName>
              <div class="sold-vehicles__item sold-vehicles__contact mt-md-2">
                <span data-test-id="vehicle-card-sold-buyer-contact-name-label" class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textBuyerContactName}}</span>
                <span class="sold-vehicles__data--buyer-contact">
                  <div class="sold-vehicles__item  sold-vehicles__buyerInfo">
                    <!-- Buyer Detail Name -->
                    <span
                      data-test-id="vehicle-card-sold-buyer-contact-name-data"
                      class="sold-vehicles__item--data sold-vehicles__buyerInfo--name" tabindex="0"
                      >{{ buyerDetailName }}
                    </span>
                  </div>
                </span>
              </div>
            </ng-template>

            <ng-template #buyerEmail>
              @if (isBuyerDetailsEmailEnabled) {
                <div data-test-id="app-vehicle-card-e-buyerEmailSold" class="sold-vehicles__item sold-vehicles__email mt-md-2">
                  <span class="text-uppercase sold-vehicles__label" data-test-id='app-vehicle-card-e-buyerEmailSold-buyer-email-label'>{{vehicleCardTranslations.textBuyerEmail}}</span>
                  <span class="sold-vehicles__data--buyer-email">
                    @if (isBuyerEmail) {
                      <span class="sold-vehicles__item--data sold-vehicles__buyerInfo--email" data-test-id='app-vehicle-card-e-buyerEmailSold-buyer-email-data' tabindex="0">{{ buyerDetailEmail }}</span>
                    }
                    @if (!isBuyerEmail) {
                      <span data-test-id='app-vehicle-card-e-buyerEmailSold-buyer-email-na' tabindex="0">{{vehicleCardTranslations.NA}}</span>
                    }
                  </span>
                </div>
              }
            </ng-template>

            <ng-template #buyerContact>
              <div class="sold-vehicles__item sold-vehicles__contact mt-md-2">
                <span data-test-id="vehicle-card-sold-buyer-contact-label" class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textBuyerContact}}</span>
                <span class="sold-vehicles__data--buyer-contact">
                  @if (buyerDetailPhone) {
                    <a
                      data-test-id="vehicle-card-sold-buyer-phone-link"
                      class="sold-vehicles__item--data sold-vehicles__buyerInfo--phone phone-link"
                      data-track-name="phone"
                      [attr.data-track-elem]="buyerDetailPhone | formatPhoneNumber"
                      [href]="buyerDetailPhone | telephoneLink"
                      [attr.aria-label]="vehicleCardTranslations.ariaLabelCall+ buyerDetailPhone"
                      >
                      {{ buyerDetailPhone | formatPhoneNumber }}
                    </a>
                  }
                  @if (!buyerDetailPhone) {
                    <span data-test-id="vehicle-card-sold-buyer-phone-na">{{vehicleCardTranslations.NA}}</span>
                  }
                </span>
              </div>
            </ng-template>

            <ng-template #buyerAuctionAccessId>
              <div class="sold-vehicles__item sold-vehicles__contact mt-md-2">
                <span data-test-id="vehicle-card-sold-buyer-auction-access-label" class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textBuyerAuctionAccess}}</span>
                <span class="sold-vehicles__data--buyer-contact">
                  <span data-test-id="vehicle-card-sold-buyer-auction-access-data" class="sold-vehicles__item--data sold-vehicles__buyerInfo--auctionAccessId">{{ buyerDetailAuctionAccessId }}</span>
                  @if (!buyerDetailAuctionAccessId) {
                    <span data-test-id="vehicle-card-sold-buyer-auction-access-na">{{vehicleCardTranslations.NA}}</span>
                  }
                </span>
              </div>
            </ng-template>

            <ng-template #buyerFinanceSource>
              @if (isCustomerInfoEnabled) {
                <div data-test-id="lib-vehicle-card-e-buyer-finance-source" class="sold-vehicles__item sold-vehicles__contact mt-md-2">
                  <span class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textBuyerFinanceSource}}</span>
                  <span class="sold-vehicles__data--buyer-finance-source">
                    <span class="sold-vehicles__item--data sold-vehicles__buyerFinanceSource">{{ buyerFinanceSourceDetail }}</span>
                  </span>
                </div>
              }
            </ng-template>

            <ng-template #customerId>
              @if (isCustomerInfoEnabled) {
                <div data-test-id="lib-vehicle-card-e-customer-id" class="sold-vehicles__item sold-vehicles__contact mt-md-2">
                  <span class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textCustomerId}}</span>
                  <span class="sold-vehicles__data--customer-id">
                    <span class="sold-vehicles__item--data sold-vehicles__customerId">{{ customerIdDetail }}</span>
                  </span>
                </div>
              }
            </ng-template>


            <ng-template #sellerNameSold>
              <li class="sold-vehicles__list-item sold-vehicles__sellerName">
                <span class="text-uppercase sold-vehicles__label" data-test-id="app-vehicle-card-e-sellerNameSold-seller-label">{{vehicleCardTranslations.textSeller}} </span>
                <!-- Seler Name | desktop not truncate -->
                @if (getSellerName.length <= 35 && isDesktop$()) {
                  <span class="sold-vehicles__data" data-test-id="app-vehicle-card-e-sellerNameSold-seller-data">{{ getSellerName }}</span>
                }
                <!-- Seler Name | desktop truncate -->
                @if (getSellerName.length > 35 && isDesktop$()) {
                  <app-tooltip [tooltip]="{ body: getSellerName }" triggers="click hover :keydown.escape :keydown.tab">
                    <span class="sold-vehicles__data" data-test-id="app-vehicle-card-e-sellerNameSold-seller-data-truncate"
                      >{{ getSellerName | nameTruncate: 35 }}
                    </span>
                  </app-tooltip>
                }
                <!-- Seler Name | mobile not truncate -->
                @if (getSellerName.length <= 20 && !isDesktop$()) {
                  <span class="sold-vehicles__data" data-test-id="app-vehicle-card-e-sellerNameSold-seller-data-mobile">{{ getSellerName }}</span>
                }
                <!-- Seler Name | mobile truncate -->
                @if (getSellerName.length > 20 && !isDesktop$()) {
                  <app-tooltip [tooltip]="{ body: getSellerName }" triggers="click hover :keydown.escape :keydown.tab">
                    <span class="sold-vehicles__data" data-test-id="app-vehicle-card-e-sellerNameSold-seller-data-mobile-truncate"
                      >{{ getSellerName | nameTruncate: 20 }}
                    </span>
                  </app-tooltip>
                }
              </li>
            </ng-template>

            <ng-template #settlementDate>
              <li class="sold-vehicles__list-item sold-vehicles__settlementDate">
                <span data-test-id="vehicle-card-sold-settlement-date-label" class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textSettlementDate}} </span>
                <span data-test-id="vehicle-card-sold-settlement-date-data" class="sold-vehicles__data"
                  >{{ settlementDateValue }}
                </span>
              </li>
            </ng-template>

            <ng-template #bidCount>
              <li class="sold-vehicles__list-item sold-vehicles-data sold-vehicles__bidCount">
                <span data-test-id="vehicle-card-sold-bid-count-label" class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textBidCount}} </span>
                <span data-test-id="vehicle-card-sold-bid-count-data" class="vehicles-details__data">{{
                  getAuctionItemSellProp('bidCount', 0)
                }}</span>
              </li>
            </ng-template>

            <ng-template #arbitration>
              <li class="sold-vehicles__list-item sold-vehicles-data sold-vehicles__arbitration">
                <span
                  class="text-uppercase sold-vehicles__label"
                  data-test-id="app-sold-vehicle-card-e-new-arbitration-case-label">{{vehicleCardTranslations.labelArbitration}}:
                </span>
                <a allytm-click-tagged='false' routerLink="./arbitration/{{ auctionItemSell$().vehicleUuid }}/new" target="_self"
                  data-track-elem="button"  (click)="analyticsClickEvent(linkEvent, openArbitrationRequest)" class="vehicles-details__data fw-bold"
                  data-test-id="app-sold-vehicle-card-e-new-arbitration-case-link">
                  {{vehicleCardTranslations.textOpenRequest}}
                </a>
              </li>
            </ng-template>

            <ng-template #arbitrationClosed>
              <app-datalist-item class=" closed-arbitration link"
                data-test-id="app-sold-vehicle-card-e-closed-arbitration-case-label"
                label="{{vehicleCardTranslations.labelArbitrationClosed}}">
                <div>
                  @for (case of closedArbitrationCases; track case; let last = $last) {
                    <p class="mb-2 text-nowrap ellipsis-overflow">
                      <a allytm-click-tagged='false'
                        class="text-primary"
                        data-test-id="app-sold-vehicle-card-e-closed-arbitration-case-link"
                        routerLink="./arbitration/{{auctionItemSell$().vehicleUuid}}/{{case.claimNumber}}"
                        [state]="{ scrollPosition: scrollPosition }" target="_self" data-track-elem="button"
                        (click)="analyticsClickEvent(linkEvent, 'Case ('+ case.claimNumber +')')">
                        {{vehicleCardTranslations.textCase}} ({{case.claimNumber}})@if (!last && closedArbitrationCases.length > 1) {
                        <span
                        >,</span>
                      }
                    </a>
                  </p>
                }
              </div>
            </app-datalist-item>
          </ng-template>


          <ng-template #serviceFee>
            @if (showTenantServiceFee) {
              <li class="sold-vehicles__list-item sold-vehicles__serviceFee sold-service-fee-details">
                @if (isBuyFees && getFeeDetailsSize(this.auctionItemSell$().buyFee.fees) > 1) {
                  <span class="sold-vehicles__data"
                    >
                    <span class="text-uppercase sold-vehicles__label">
                      {{vehicleCardTranslations.textFees}}
                    </span>
                    {{ buyFeesTotalAmount ? formatCurrency(buyFeesTotalAmount, true): vehicleCardTranslations.NA }}
                    <app-tooltip
                      data-test-id="vehicle-card-sold-service-fee-tooltip"
                      [tooltip]="feeDetailsTooltip"
                      [showToolTipAsHtml]="true"
                      triggers="click :keydown.escape :keydown.tab"
                      (click)="analyticsInfo('Service Fee Details')"
                      allytmln="Service Fee Details">
                      <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                    </app-tooltip>
                  </span>
                }
                @if (isBuyFees && getFeeDetailsSize(this.auctionItemSell$().buyFee.fees) == 1) {
                  <span>
                    <span class="text-uppercase sold-vehicles__label">{{singleFeeLabel}}:</span>
                    <span class="vehicles-details__data">
                      ${{singleFeeAmount | number: '1.2-2' }}
                    </span>
                  </span>
                }
              </li>
            }
          </ng-template>

          <ng-template #localDelivery>
            @if (showDeliveryField) {
              <li class="sold-vehicles__list-item sold-vehicles__deliveryIncluded">
                <span data-test-id="vehicle-card-sold-local-delivery-label" class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textDelivery}} </span>
                <span data-test-id="vehicle-card-sold-local-delivery-data" class="sold-vehicles__data">{{localDeliveryValue}}
                </span>
              </li>
            }
          </ng-template>

          <ng-template #tenantBadge>
            @if (isTenantBadgeEnabled && isTenantBadgeValue) {
              <li class="sold-vehicles__list-item sold-vehicles__tenant-badge">
                <span data-test-id="vehicle-card-sold-tenant-badge-label" class="text-uppercase sold-vehicles__label">{{vehicleCardTranslations.textTenantBadgeLowerCase}} </span>
                <!-- Sold vehicle Tenant Badge | desktop not truncate -->
                @if (tenantBadgeValue.length <= 30 && isDesktop$()) {
                  <span
                    data-test-id="vehicle-card-sold-tenant-badge-data"
                    class="sold-vehicles__data sold-vehicles_tenant-badge"
                    >{{ tenantBadgeValue }}</span
                    >
                  }
                  <!-- Sold vehicle Tenant Badge | desktop truncate -->
                  @if (tenantBadgeValue.length > 30 && isDesktop$()) {
                    <app-tooltip [tooltip]="{ body: tenantBadgeValue }" triggers="click hover :keydown.escape :keydown.tab">
                      <span
                        data-test-id="vehicle-card-sold-tenant-badge-data-truncate"
                        class="sold-vehicles__data sold-vehicles_tenant-badge"
                        >{{ tenantBadgeValue | nameTruncate: 30 }}
                      </span>
                    </app-tooltip>
                  }
                  <!-- Sold vehicle Tenant Badge | mobile not truncate -->
                  @if (tenantBadgeValue.length <= 20 && !isDesktop$()) {
                    <span
                      data-test-id="vehicle-card-sold-tenant-badge-data-mobile"
                      class="sold-vehicles__data sold-vehicles_tenant-badge"
                      >{{ tenantBadgeValue }}</span
                      >
                    }
                    <!-- Sold vehicle Tenant Badge | mobile truncate -->
                    @if (tenantBadgeValue.length > 20 && !isDesktop$()) {
                      <app-tooltip [tooltip]="{ body: tenantBadgeValue }" triggers="click hover :keydown.escape :keydown.tab">
                        <span
                          data-test-id="vehicle-card-sold-tenant-badge-data-mobile-truncate"
                          class="sold-vehicles__data sold-vehicles_tenant-badge"
                          >{{ tenantBadgeValue | nameTruncate: 20 }}
                        </span>
                      </app-tooltip>
                    }
                  </li>
                }
              </ng-template>

              <ng-template #sellerNameActive>
                <li class="vehicles-details__item">
                  <span class="vehicles-details__label" data-test-id="app-vehicle-card-e-sellerNameActive-seller-label">{{vehicleCardTranslations.textSellerUpperCase}} </span>
                  <span class="vehicles-details__data" data-test-id="app-vehicle-card-e-sellerNameActive-seller-data">
                    <!--  Desktop no truncate or tooltip -->
                    @if (isDesktop$() && getSellerName.length <= 25) {
                      {{ getSellerName }}
                    }
                    <!--  Desktop truncate seller name and tooltip -->
                    @if (isDesktop$() && getSellerName.length > 25) {
                      <app-tooltip [tooltip]="{ body: getSellerName }" triggers="click hover :keydown.escape :keydown.tab">
                        {{ getSellerName | nameTruncate: 25 }}
                      </app-tooltip>
                    }

                    <!--  Mobile no truncate or tooltip -->
                    @if (!isDesktop$() && getSellerName.length <= 18) {
                      {{ getSellerName }}
                    }
                    <!--  Mobile truncate seller name and tooltip -->
                    @if (!isDesktop$() && getSellerName.length > 18) {
                      <app-tooltip [tooltip]="{ body: getSellerName }" triggers="click hover :keydown.escape :keydown.tab">
                        {{ getSellerName | nameTruncate: 18 }}
                      </app-tooltip>
                    }
                  </span>
                </li>
              </ng-template>

              <ng-template #printContent>
                <!--  Have to set up the id correctly so the print button will know which section to print -->
                <div class="print-card p-5" id="{{ auctionItemSell$().vehicleUuid }}">
                  <div class="body pt-5 px-5">
                    <h3 class="ps-3 title print-subtitle">{{vehicleCardTranslations.textVehicleSummary}}</h3>
                    <h5 class="vehicle-title ps-3 mt-4">
                      <span>{{ detail('modelYear') }} </span>
                      <span>{{ detail('make') }} </span>
                      <span>{{ detail('model') }} </span>
                      <span>{{ detail('trim') }} </span>
                      <span>{{ driveTrain }}</span>
                    </h5>
                    <div class="ps-3">
                      <span class="print-card-label">{{ vehicleCardTranslations.textVin | uppercase }}</span>
                      <span class="me-5">{{ (auctionItemSell$()?.itemDetail?.vin ? auctionItemSell$().itemDetail.vin : vehicleCardTranslations.NA) | uppercase }}</span>
                      <span class="print-card-label">{{ vehicleCardTranslations.textStockUnit }}</span>
                      <span>{{ (auctionItemSell$()?.itemDetail?.stockNumber ? auctionItemSell$().itemDetail.stockNumber : vehicleCardTranslations.NA) | uppercase }}</span>
                    </div>
                    <br>

                      @if (isNotDirty) {
                        <div class="d-flex ps-3">
                          <div class="column-1 sold-vehicles__desktop-column">
                            <ng-content *ngTemplateOutlet="mailTitleToSectionPrint"></ng-content>
                            @if (isTenantCanadian()) {
                              <br>
                                <ng-content *ngTemplateOutlet="buyerInfoSectionPrint"></ng-content>
                              }
                            </div>
                            <div class="column-2 sold-vehicles__desktop-column">
                              @if (isTenantCanadian()) {
                                <ng-content *ngTemplateOutlet="salesInfoSectionPrint"></ng-content>
                              }
                              @if (!isTenantCanadian()) {
                                <ng-content *ngTemplateOutlet="buyerInfoSectionPrint"></ng-content>
                              }
                            </div>
                            <div class="column-3 sold-vehicles__desktop-column">
                              @if (isTenantCanadian()) {
                                @if (sellerRemitDto) {
                                  <ng-content *ngTemplateOutlet="buyerTaxesSectionPrint"></ng-content>
                                  <br>
                                  }
                                  <ng-content *ngTemplateOutlet="sellerFeesAndTaxesSectionPrint"></ng-content>
                                }
                                @if (!isTenantCanadian()) {
                                  <ng-content *ngTemplateOutlet="salesInfoSectionPrint"></ng-content>
                                }
                              </div>
                            </div>
                          }

                          <br>
                            <hr>
                              <div class="sale-info ps-3">

                                @if (!isTenantCanadian()) {
                                  <span class="print-card-label">{{ vehicleCardTranslations.textSaleFee | uppercase }}</span>
                                  <span class="me-5">{{ sellFeesTotalAmount ? (sellFeesTotalAmount | currency: 'USD':'symbol':'1.0-2') : vehicleCardTranslations.NA }}</span>
                                  <span class="print-card-label">{{vehicleCardTranslations.textVehiclePrice | uppercase}}</span>
                                  <span class="me-5">{{ auctionItemSell$().salePrice ? (auctionItemSell$().salePrice | currency: 'USD':'symbol':'1.0-0') : vehicleCardTranslations.NA }}</span>
                                  <span class="print-card-label">{{ vehicleCardTranslations.textSaleDateTime | uppercase}}</span>
                                  <span class="me-5">{{ saleDateTime }}</span>
                                }

                              </div>

                              @if (isTenantCanadian()) {
                                <div class="platform-info ps-3 mt-4">
                                  <span class="print-card-label">{{ vehicleCardTranslations.textAuction | uppercase }}</span>
                                  <span>{{ platformTenantName }}&nbsp;&nbsp;{{ platformAddress }}</span>
                                  <br>
                                    <span class="print-card-label">{{ vehicleCardTranslations.textProvider | uppercase }}</span>
                                    <span>{{ platformProvider }}</span>
                                  </div>
                                }
                              </div>
                            </div>
                          </ng-template>

                          <ng-template #mailTitleToSectionPrint>
                            <p class="print-card-column-title pb-2">{{ vehicleCardTranslations.textMailTitleTo | uppercase }}</p>
                            <p class="p-0 my-0">{{ titleAddressName }}</p>
                            <p class="p-0 my-0">{{ titleAddressDetail }}</p>
                            @if (titleAddressDetail2.length > 0) {
                              <p class="p-0 my-0">{{ titleAddressDetail2 }}</p>
                            }
                            <p class="p-0 my-0">{{ titleAddressRegion }}</p>
                            @if (isTitleContactEnabled) {
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{ vehicleCardTranslations.textTitleContactName | uppercase }}</span>
                                <span>{{ titleContactName }}</span>
                              </p>
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{ vehicleCardTranslations.textTitleContactEmail | uppercase }}</span>
                                <span>{{ titleContactEmail }}</span>
                              </p>
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{ vehicleCardTranslations.textTitleContactPhone | uppercase }}</span>
                                @if (titleContactPhone) {
                                  <span>{{ titleContactPhone | formatPhoneNumber }}</span>
                                } @else {
                                  <span>{{ vehicleCardTranslations.NA }}</span>
                                }
                              </p>
                            }
                          </ng-template>

                          <ng-template #buyerInfoSectionPrint>
                            <p class="print-card-column-title pb-2">{{ vehicleCardTranslations.textBuyerInfoUpper | uppercase }}</p>
                            <p class="p-0 my-0">{{ buyerDetailsName }}</p>
                            <p class="p-0 my-0">{{ buyerDetailsAddress }}</p>
                            @if (buyerDetailsAddress2.length > 0) {
                              <p class="p-0 my-0">{{ buyerDetailsAddress2 }}</p>
                            }
                            <p class="p-0 my-0">{{ buyerDetailRegion }}</p>
                            <p class="p-0 my-0">
                              <span class="print-card-label">{{ vehicleCardTranslations.textDealershipContact  | uppercase }}</span>
                              @if (buyerDetailsPrimaryPhone) {
                                <span>{{ buyerDetailsPrimaryPhone | formatPhoneNumber }}</span>
                              }
                              @if (!buyerDetailsPrimaryPhone) {
                                <span>{{vehicleCardTranslations.NA}}</span>
                              }
                            </p>
                            <p class="p-0 my-0">
                              <span class="print-card-label">{{ vehicleCardTranslations.textBuyerContactName | uppercase }}</span>
                              @if (buyerDetailName) {
                                <span>{{ buyerDetailName }}</span>
                              }
                              @if (!buyerDetailName) {
                                <span>{{vehicleCardTranslations.NA}}</span>
                              }
                            </p>
                            @if (isBuyerDetailsEmailEnabled) {
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{ vehicleCardTranslations.textBuyerEmail | uppercase }}</span>
                                @if (buyerDetailEmail) {
                                  <span>{{ buyerDetailEmail }}</span>
                                }
                                @if (!buyerDetailEmail) {
                                  <span>{{vehicleCardTranslations.NA}}</span>
                                }
                              </p>
                            }
                            <p class="p-0 my-0">
                              <span class="print-card-label">{{ vehicleCardTranslations.textBuyerContact | uppercase }}</span>
                              @if (buyerDetailPhone) {
                                <span>{{ buyerDetailPhone | formatPhoneNumber }}</span>
                              }
                              @if (!buyerDetailPhone) {
                                <span>{{vehicleCardTranslations.NA}}</span>
                              }
                            </p>
                            <p class="p-0 my-0">
                              <span class="print-card-label">{{ vehicleCardTranslations.textBuyerAuctionAccess  | uppercase }}</span>
                              @if (buyerDetailAuctionAccessId) {
                                <span>{{ buyerDetailAuctionAccessId }}</span>
                              }
                              @if (!buyerDetailAuctionAccessId) {
                                <span>{{vehicleCardTranslations.NA}}</span>
                              }
                            </p>

                          </ng-template>

                          <ng-template #salesInfoSectionPrint>
                            <p class="print-card-column-title pb-2">{{ vehicleCardTranslations.textSalesInformation | uppercase }}</p>
                            <p class="p-0 my-0">
                              <span class="print-card-label">{{ vehicleCardTranslations.textSeller| uppercase }}</span>
                              <span>{{ getSellerName }}</span>
                            </p>
                            <p class="p-0 my-0">
                              <span class="print-card-label">{{ vehicleCardTranslations.textTenantBadge | uppercase }}</span>
                              <span>{{ tenantBadgeValue }}</span>
                            </p>
                            <p class="p-0 my-0">
                              <span class="print-card-label">{{ vehicleCardTranslations.textSettlementDate | uppercase }}</span>
                              <span>{{ settlementDateValue }}</span>
                            </p>
                            <p class="p-0 my-0">
                              <span class="print-card-label">{{ vehicleCardTranslations.textHits | uppercase }}</span>
                              <span>{{getAuctionItemSellProp('viewCount', 0)}}</span>
                            </p>
                            <p class="p-0 my-0">
                              <span class="print-card-label">{{ vehicleCardTranslations.textBidCount | uppercase }}</span>
                              <span>{{ getAuctionItemSellProp('bidCount', 0) }}</span>
                            </p>
                            @if (isTenantCanadian()) {
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{ vehicleCardTranslations.textVehiclePrice | uppercase}}</span>
                                <span>{{ auctionItemSell$().salePrice ? (auctionItemSell$().salePrice | currency: 'USD':'symbol':'1.0-0') : vehicleCardTranslations.NA}}</span>
                              </p>
                            }

                            @if (showTenantServiceFee) {
                              @if (!isTenantCanadian() && getBuyFeeDetailsSizeForPrint(this.auctionItemSell$().buyFee.fees) < 2) {
                                <p class="p-0 my-0">
                                  <span class="print-card-label">{{singleFeeLabel | uppercase }}:</span>
                                  <span>{{ buyFeesTotalAmount | currency: 'USD':'symbol':'1.0-2' }}</span>
                                </p>
                              }
                              @if (getBuyFeeDetailsSizeForPrint(this.auctionItemSell$().buyFee.fees) == 1 || getBuyFeeDetailsSizeForPrint(this.auctionItemSell$().buyFee.fees) > 1) {
                                @for (fee of buyFeesForPrint | keyvalue : returnUndefined(); track fee) {
                                  <p class="p-0 my-0">
                                    <span class="print-card-label">{{fee.key | uppercase }}:</span>
                                    <span>{{ fee.value | currency: 'USD':'symbol':'1.0-2' }}</span>
                                  </p>
                                }
                              }
                            }
                            @if (isTenantCanadian()) {
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{vehicleCardTranslations.textSaleDateTime | uppercase}}</span>
                                <span>{{ saleDateTime }}</span>
                              </p>
                            }
                          </ng-template>

                          <ng-template #buyerTaxesSectionPrint>
                            <p class="print-card-column-title pb-0">{{vehicleCardTranslations.textBuyerTaxes | uppercase }}</p>
                            <p class="buyer-taxes-sub-text pt-0 my-0 mt-n4 pb-2">{{ vehicleCardTranslations.textBuyerTaxesSub }}</p>

                            <!-- ProceedsFederalTax will always be non-null -->
                            @if (sellerRemitDto.proceedsFederalTax) {
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{ vehicleCardTranslations.textPriceFederalTaxLabel | uppercase }}</span>
                                <span>{{ sellerRemitDto.proceedsFederalTax | currency }}</span>
                              </p>
                            }
                            @if (sellerRemitDto.proceedsStateTax) {
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{ vehicleCardTranslations.textPriceStateTaxLabel | uppercase }}</span>
                                <span>{{ sellerRemitDto.proceedsStateTax | currency }}</span>
                              </p>
                            }
                            @if (sellerRemitDto.feesFederalTax) {
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{ vehicleCardTranslations.textFeesFederalTaxLabel | uppercase }}</span>
                                <span>{{ sellerRemitDto.feesFederalTax | currency }}</span>
                              </p>
                            }
                            @if (sellerRemitDto.feesStateTax) {
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{ vehicleCardTranslations.textFeesStateTaxLabel | uppercase }}</span>
                                <span>{{ sellerRemitDto.feesStateTax | currency }}</span>
                              </p>
                            }
                          </ng-template>
                          <ng-template #sellerFeesAndTaxesSectionPrint>
                            @if (this.auctionItemSell$()?.sellFee?.fees && getSellFeeDetailsSizeForPrint(this.auctionItemSell$()?.sellFee?.fees) === 1) {
                              <p class="print-card-column-title pb-2">{{vehicleCardTranslations.textSellerFeesAndTaxes | uppercase }}</p>
                              <p class="p-0 my-0">
                                <span class="print-card-label">{{ singleFeeLabel | uppercase }}:</span>
                                <span>{{ sellFeesTotalAmount ? (sellFeesTotalAmount | currency) : vehicleCardTranslations.NA }}</span>
                              </p>
                            }
                            @if (this.auctionItemSell$()?.sellFee?.fees && getSellFeeDetailsSizeForPrint(this.auctionItemSell$()?.sellFee?.fees) > 1) {
                              <p class="print-card-column-title pb-2">{{vehicleCardTranslations.textSellerFeesAndTaxes | uppercase }}</p>
                              @for (fee of sellFeesForPrint | keyvalue : returnUndefined(); track fee) {
                                <p class="p-0 my-0">
                                  <span class="print-card-label">{{fee.key | uppercase }}:</span>
                                  <span>{{ fee.value | currency }}</span>
                                </p>
                              }
                            }
                          </ng-template>

                          <ng-template #daysOnHold>
                            <li class="vehicles-details__item">
                              <span data-test-id="vehicle-card-hold-days-on-hold-label" class="vehicles-details__label">{{vehicleCardTranslations.textDaysOnHold}} </span>
                              <span data-test-id="vehicle-card-hold-days-on-hold-data" class="vehicles-details__data">{{
                                getAuctionItemSellProp('holdDays', 0)
                              }}</span>
                            </li>
                          </ng-template>

                          <ng-template #postingPrice>
                            <li class="vehicles-details__item">
                              <span data-test-id="vehicle-card-hold-posting-price-label" class="vehicles-details__label">{{vehicleCardTranslations.textPostingPrice}} </span>
                              <span data-test-id="vehicle-card-hold-posting-price-data" class="vehicles-details__data">{{ currentAmount
                                ? formatCurrency(currentAmount)
                                : vehicleCardTranslations.NA }}
                              </span>
                            </li>
                          </ng-template>

                          <ng-template #holdReasonTmpl>
                            @if (holdReasonList?.length) {
                              <li class="vehicles-details__item d-md-flex align-items-baseline">
                                <div class="vehicles-details__label" [ngPlural]="holdReasonList.length">
                                  <ng-template ngPluralCase="one">{{vehicleCardTranslations.textHoldReason}} </ng-template>
                                  <ng-template ngPluralCase="other">{{vehicleCardTranslations.textHoldReasons}} </ng-template>
                                </div>
                                <div class="vehicles-details__data col-md-6 ps-0 pe-0">
                                  @for (item of holdReasonList; track item; let i = $index; let isLast = $last) {
                                    <div [data-test-id]="'vehicle-card-hold-hold-reason-item-' + i">
                                      {{item}}@if (!isLast) {
                                      <span>,</span>
                                    }
                                  </div>
                                }
                              </div>
                            </li>
                          }
                        </ng-template>

                          <ng-template #removalReason>
                            <li class="vehicles-details__item">
                              <span data-test-id="vehicle-card-removed-removal-reason-label" class="vehicles-details__label">{{vehicleCardTranslations.textRemovalReason}} </span>
                              <span data-test-id="vehicle-card-removed-removal-reason-data" class="vehicles-details__data">
                                <!--  Desktop no truncate or tooltip -->
                                @if (isDesktop$() && getRemovalReason.length <= 25) {
                                  {{ getRemovalReason }}
                                }
                                <!--  Desktop truncate seller name and tooltip -->
                                @if (isDesktop$() && getRemovalReason.length > 25) {
                                  <app-tooltip [tooltip]="{ body: getRemovalReason }" triggers="click hover :keydown.escape :keydown.tab">
                                    {{ getRemovalReason | nameTruncate: 25 }}
                                  </app-tooltip>
                                }

                                <!--  Mobile no truncate or tooltip -->
                                @if (!isDesktop$() && getRemovalReason.length <= 18) {
                                  {{ getRemovalReason }}
                                }
                                <!--  Mobile truncate seller name and tooltip -->
                                @if (!isDesktop$() && getRemovalReason.length > 18) {
                                  <app-tooltip [tooltip]="{ body: getRemovalReason }" triggers="click hover :keydown.escape :keydown.tab">
                                    {{ getRemovalReason | nameTruncate: 18 }}
                                  </app-tooltip>
                                }
                              </span>
                            </li>
                          </ng-template>

                          <ng-template #postedDate>
                            <li class="vehicles-details__item">
                              <span data-test-id="vehicle-card-removed-posted-date-label" class="vehicles-details__label">{{vehicleCardTranslations.textPostedDate}} </span>
                              <span data-test-id="vehicle-card-removed-posted-date-data" class="time__content">{{
                                datePosted
                              }}</span>
                            </li>
                          </ng-template>

                          <ng-template #bidListAdds>
                            <li class="vehicles-details__item">
                              <span data-test-id="vehicle-card-removed-bid-list-adds-label" class="vehicles-details__label">{{vehicleCardTranslations.textBidListAdds}} </span>
                              <span data-test-id="vehicle-card-removed-bid-list-adds-data" class="vehicles-details__data">{{
                                getAuctionItemSellProp('bidListAdds', 0)
                              }}</span>
                            </li>
                          </ng-template>

                          <ng-template #fees>
                            <li class="vehicles-details__item">
                              <span data-test-id="vehicle-card-removed-fees-label" class="vehicles-details__label">{{vehicleCardTranslations.textFees}} </span>
                              <span data-test-id="vehicle-card-removed-fees-data" class="vehicles-details__data">
                                {{auctionItemSell$()?.saleFee != null && auctionItemSell$()?.saleFee !== undefined  ? formatCurrency(auctionItemSell$().saleFee) : vehicleCardTranslations.NA}}
                              </span>
                            </li>
                          </ng-template>

                          <ng-template #removals>
                            <li class="vehicles-details__item">
                              <span class="vehicles-details__label" data-test-id="app-vehicle-card-e-removals-seller-label">{{vehicleCardTranslations.textRemovals}} </span>
                              <span class="vehicles-details__data" data-test-id="app-vehicle-card-e-removals-seller-data">
                                {{auctionItemSell$()?.removalCount || 1 }} {{vehicleCardTranslations.withinNinetyDays}}</span>
                            </li>
                          </ng-template>

                          <ng-template #highestOfferPrice>
                            <li class="vehicles-details__item">
                              <span data-test-id="vehicle-card-removed-highest-offer-label" class="vehicles-details__label">{{vehicleCardTranslations.textHighestOfferPrice}} </span>
                              <span data-test-id="vehicle-card-removed-highest-offer-data" class="vehicles-details__data">{{
                                highestOffer ? (highestOffer | currency: 'USD':'symbol':'1.0-0') : vehicleCardTranslations.NA
                              }}</span>
                            </li>
                          </ng-template>

                          <ng-template #totalPrice>
                            @if ((auctionItemSell$().salePrice || auctionItemSell$().offerAmount) && singleListSelected$()) {
                              <span class="divider">|</span>
                              <span data-test-id="vehicle-card-actions-total-price-label" class="text-uppercase me-2 sold-vehicles-label">{{vehicleCardTranslations.textTotalPrice}} </span>
                              <span data-test-id="vehicle-card-actions-total-price-data">
                                {{ calculatedTotalPrice ? (calculatedTotalPrice | currency: 'USD':'symbol':'1.2-2') : vehicleCardTranslations.NA }}
                              </span>
                              <span>
                                <app-tooltip
                                  data-test-id="vehicle-card-actions-total-price-tooltip"
                                  [tooltip]="feeDetailsTooltip"
                                  [showToolTipAsHtml]="true"
                                  triggers="click :keydown.escape :keydown.tab"
                                  (click)="analyticsInfo('Service Fee Details')"
                                  allytmln="Service Fee Details">
                                  <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                                </app-tooltip>
                              </span>
                              }
                          </ng-template>


                            <ng-template #sharedListWarning>
                                <span class="mobile-row">
                                  <span [class]="partOfSharedListClassList" data-test-id="app-vehicle-card-shared-list-warning">
                                    <img class="icon-warning-filled-orange" src="assets/icons/icon-warning-filled/icon-warning-filled-orange.svg" alt="Warning Icon">
                                    {{ vehicleCardTranslations.partOf }}
                                    <app-tooltip [showToolTipAsHtml]="true" [tooltip]="offerListsTooltip" class="hover-tooltip" triggers="click :keydown.escape" [allowOutsideClick]=false>
                                      <span class="shared-text text-bold">
                                        {{ currentListType$() }}
                                      </span>
                                    </app-tooltip>
                                  </span>
                                </span>
                            </ng-template>

                            <ng-template #disclosures>
                              @if (isSellVehicleCardDisclosuresEnabled) {
                                <div class="vehicles-details__item data-list-with-tooltip-container">
                                  <app-datalist-item data-test-id="vehicle-card-disclosures-item" [identifier]="'vehicle_disclosures_text_' + index$()"
                                    label="{{vehicleCardTranslations.labelDisclosures}}" [value]="
                                          auctionItemSell$()?.disclosures?.limitedArbitration ||
                                          auctionItemSell$()?.disclosures?.yellowLights?.length > 0
                                           ? ''
                                            : vehicleCardTranslations.NA">
                              </app-datalist-item>

                              @if (limitedArbitration) {
                                <app-tooltip data-test-id="vehicle-card-disclosures-red-tooltip" class="tool-tip-red-manage-inventory" triggers="hover click :keydown.escape :keydown.tab"
                                  [tooltip]="disclosureToolTipRed"
                                  [attr.aria-label]="vehicleCardTranslations.arealabelRedlight">
                                  <div class="tooltip-letter bg-danger text-white"><span
                                  aria-hidden="true">{{vehicleCardTranslations.toolTipLetterRedlight}}</span></div>
                                </app-tooltip>
                              }
                              <div class="yellow-lights-disclosures">
                                @if (yellowLightDisclosureCount) {
                                  <app-vehicle-disclosures-indicator data-test-id="vehicle-card-disclosures-yellow-indicator" variant="yellow" [vehicleDisclosuresCount] = yellowLightDisclosureCount
                                    [vehicleDisclosuresIndicatorTranslations]="conditionIndicatorTranslations"
                                    [vehicleDisclosuresList]="yellowLightDisclosureList" [bulletedToolTipContentToolTipOverCount]=true
                                    [small]="true"
                                    >
                                  </app-vehicle-disclosures-indicator>
                                }
                              </div>
                            </div>
                          }
                        </ng-template>
                      </ng-container>
                      <ng-template appModalPortal></ng-template>
                      <app-error-modal></app-error-modal>
